/**
 * 这里是ajax的通用访问接口处理
 */
import axios from 'axios';
import Qs from 'qs';
import './expromise';
import Message from './msgbox';

const toString = Object.prototype.toString;
const service = axios.create({
  baseURL: '',
  timeout: 60000,
  transformRequest: function (data, config, test) {
    return Qs.stringify(data);
  },
  headers: {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

const showMessage = (message, type = 'error') => {
  Message({
    showClose: true,
    type: type,
    duration: 4000,
    message,
  });
};

/**
 * 服务端接口empty字符串跟null返回的结果不同，过滤掉empty字符串
 * @param params
 * @param emptyString 是否过滤空字符串
 */
function filterEmptyKey(params, emptyString) {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || (emptyString && params[key] === '')) {
      delete params[key];
    }
  });
}

service.interceptors.request.use(
  (config) => {
    if (config.method === 'post') {
      const params = {
        ...config.data,
      };
      filterEmptyKey(params, false);
      const lowerUrl = (config.url + '').toLocaleLowerCase();
      const hasAbsoluteSchema = config.url.indexOf('http') === 0;
      if (!hasAbsoluteSchema) {
        if (lowerUrl.indexOf('/dsp/') > -1 || lowerUrl.indexOf('/dmp/') > -1) {
          for (const key in params) {
            const type = toString.call(params[key]);
            if (type === '[object Object]' || type === '[object Array]') {
              params[key] = JSON.stringify(params[key]);
            }
          }
        }
      }

      // params._t = Date.parse(new Date()) / 1000;
      config.data = params;
    } else if (config.method === 'get') {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params,
      };
      filterEmptyKey(config.params, true);
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (res) => {
    const { data, config } = res;
    if ((!data.success || data.success === 'false') && data.code !== 200) {
      const msg = data.errorMessage || data.message || data.msg || '未知错误';
      const code = data.code || -1000;

      // 未手动配置 隐藏 消息提示时，公共提醒错误
      if (!config.hidden) {
        showMessage(`${config.action}失败：${msg}`);
      }

      // 登录权限跳转
      if (code === 401) {
        setTimeout(() => {
          const url = encodeURIComponent(window.location.href);
          window.top.location.href = `/login.html?gotoUrl=${url}`;
        }, 1000);
      }

      // return Promise.reject(new Error('请求失败'))
      return Promise.reject({
        code: code,
        message: msg,
      });
    }

    return data || {};
  },
  (error) => {
    if (!error.config.hidden) {
      let message = error.message;
      if (error.response && error.response.status === 403) {
        message = '您没有该权限';
      } else if (error.response && error.response.status === 502) {
        message = '系统升级中，请稍后重试';
      } else if (error.response && error.response.status === 504) {
        message = '系统超时，请重试';
      }
      showMessage(`${error.config.action}失败：${message}`);
    }
    return Promise.reject(error);
  }
);

/**
 * 以json格式向后端提交数据
 *
 * @param {String} url 请求的url
 * @param {Object} params 参数
 * @param {Object} config 配置
 *
 * @returns promise对象
 */
service.json = (url, params, config) => {
  const isArray = Object.prototype.toString.call(params) === '[object Array]';
  const defaultConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    transformRequest: function (data, requestConfig) {
      if (isArray) {
        return JSON.stringify(params);
      }
      return JSON.stringify(data);
    },
  };
  const newConfig = Object.assign(defaultConfig, config);
  return service.post(url, params, newConfig);
};

/**
 * 带有数组参数的get请求，需要对数组参数转换，如ids: [1, 2, 3]转换成ids=1&ids=2&ids=3
 * @param url
 * @param config
 * @return {AxiosPromise<any>}
 */
service.arrayGet = (url, config) => {
  if (config) {
    config.paramsSerializer = function (params) {
      return Qs.stringify(params, { arrayFormat: 'repeat' });
    };
  }
  return service.get(url, config);
};

export default service;
